import { v4 as uuid } from "uuid";
import  {book1,book2,book3,book4,book5,book6,book7,book8,book9,book10,book11,book12,book13,book14,book15,
  book16,book17,book18,book19,book20,book21,book22,book23,book24} from "../../assets"
/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */


export const products = [
  {
    _id: uuid(),
    id:"The_Great_Gatsby",
    title: "The Great Gatsby",
    img:book1,
    price: "109",
    original_price:"149",
    isPopular:false,
    rating:4.5,
    desc:"It's the Roaring Twenties and New York City is the place to be. Everything can be purchased, everyone can be bought. But, can you make money erase your past? As more and more people lose themselves to the lure of money, ironically the only person who remains unaffected is Jay Gatsby, the enigmatic host of the most extravagant parties.",
    categoryName: "fiction",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "Kite_Runner",
    title: "Kite Runner",
    img:book2,
    price: "284",
    original_price:"599",
    isPopular:true,
    rating:4.8,
    desc:"Afghanistan, 1975: Twelve-year-old Amir is desperate to win the local kite-fighting tournament and his loyal friend Hassan promises to help him. But neither of the boys can foresee what will happen to Hassan that afternoon, an event that is to shatter their lives. After the Russians invade and the family is forced to flee to America, Amir realises that one day he must return to Afghanistan under Taliban rule to find the one thing that his new world cannot grant him: redemption.",
    categoryName: "fiction",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "The_Alchemist",
    title: "The Alchemist",
    img:book3,
    price: "235",
    original_price:"350",
    isPopular:true,
    rating:4.3,
    desc:"Paulo Coelho's enchanting novel has inspired a devoted following around the world. This story, dazzling in its powerful simplicity and inspiring wisdom, is about an Andalusian shepherd boy named Santiago who travels from his homeland in Spain to the Egyptian desert in search of a treasure buried in the Pyramids.",
    categoryName: "fiction",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "India_to_Pakistan",
    title: "India to Pakistan",
    img:book4,
    price: "443",
    original_price:"899",
    isPopular:true,
    rating:4,
    desc:"ndia, Bharat and Pakistan, the second book of the Bharat Trilogy, takes the discussion forward from its bestselling predecessor, India That Is Bharat. It explores the combined influence of European and Middle Eastern colonialities on Bharat as the successor state to the Indic civilisation, and on the origins of the Indian Constitution. To this end, the book traces the thought continuum of Middle Eastern coloniality from the rise of Islamic Revivalism in the 1740s following the decline of the Mughal Empire, which presaged the idea of Pakistan, until the end of the Khilafat Movement in 1924, which cemented the road to Pakistan",
    categoryName: "fiction",
    deliveryCharge:false
  },
  {
    _id: uuid(),
    id: "Life_of_Pie",
    title: "Life of Pie",
    img:book5,
    price: "527",
    original_price:"800",
    isPopular:false,
    rating:3.5,
    desc:"The game is a first-person shooter. The player assumes control of Ryan Marks, a former Special Forces soldier who must save his family from a London crime boss. Players can hide behind cover and pick up different guns to shoot enemies. To move in the game, players only need to look at a spot and press a button.",
    categoryName: "fiction",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "Narcopolis",
    title: "Narcopolis",
    img:book6,
    price: "934",
    original_price:"1527",
    isPopular:true,
    rating:4.9,
    desc:"Narcopolis is the debut novel of Indian author Jeet Thayil, which was shortlisted for the 2012 Man Booker Prize. It is set in 1970s Old Bombay and concerns opium and its influence. The novel's narrator arrives in Bombay, where he becomes seduced into the opium underground.",
    categoryName: "fiction",
    deliveryCharge:false
  },
  {
    _id: uuid(),
    id: "Immortal_of_Meluha",
    title: "The Immortals of Meluha",
    img:book7,
    price: "380",
    original_price:"399",
    isPopular:true,
    rating:4.6,
    desc:"The Immortals of Meluha is the first book of Amish Tripathi, first book of Amishverse, and also the first book of Shiva Trilogy. The story is set in the land of Meluha and starts with the arrival of the Shiva. The Meluhans believe that Shiva is their fabled saviour Neelkanth.",
    categoryName: "fiction",
    deliveryCharge:false
  },
  {
    _id: uuid(),
    id: "AMERICANAH",
    title: "AMERICANAH",
    img:book8,
    price: "321",
    original_price:"620",
    isPopular:true,
    rating:4.7,
    desc:"As teenagers in Lagos, Ifemelu and Obinze fall in love. Their Nigeria is under military dictatorship, and people are fleeing the country if they can. The self-assured Ifemelu departs for America. There she suffers defeats and triumphs, finds and loses relationships, all the while feeling the weight of something she never thought of back home: race. ",
    categoryName: "fiction",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "RAW_DOG",
    title: "Raw Dog: The Naked Truth About Hot Dogs",
    img:book9,
    price: "200",
    original_price:"350",
    isPopular:false,
    rating:4.4,
    desc:"Part travelogue, part culinary history, all capitalist critique—comedian Jamie Loftus's debut, Raw Dog, will take you on a cross-country road trip in the summer of 2021, and reveal what the creation, culture, and class influence of hot dogs says about America now.",
    categoryName: "non-fiction",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "Soil",
    title: "Soil: The Story of a Black Mother's Garden",
    img:book10,
    price: "5000",
    original_price:"6500",
    isPopular:true,
    rating:4.7,
    desc:"Poet and scholar Camille T. Dungy recounts the seven-year odyssey to diversify her garden in the predominately white community of Fort Collins, Colorado.When she moved there in 2013, with her husband and daughter, the community held strict restrictions about what residents could and could not plant in their garde",
    categoryName: "non-fiction",
    deliveryCharge:false
  },
  {
    _id: uuid(),
    id: "Povery_by_America",
    title: "Poverty By America",
    img:book11,
    price: "1985",
    original_price:"2324",
    isPopular:true,
    rating:4.8,
    desc:"The United States, the richest country on earth, has more poverty than any other advanced democracy. Why? Why does this land of plenty allow one in every eight of its children to go without basic necessities, permit scores of its citizens to live and die on the streets, and authorize its corporations to pay poverty wages? ",
    categoryName: "non-fiction",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "Energize_your_Mind",
    title: "Energize Your Mind",
    img:book12,
    price: "299",
    original_price:"399",
    isPopular:false,
    rating:4.2,
    desc:"In this book, bestselling author and life coach Gaur Gopal Das decodes how the mind works. He combines his anecdotal style with analytical research to teach us how to discipline our mind for our greater well-being. Throughout this book, he provides interactive exercises, meditation techniques and worksheets to help us take charge of our mind.",
    categoryName: "non-fiction",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "Real_unreal_cosmos",
    title: "Real Unreal Cosmos",
    img:book13,
    price: "215",
    original_price:"215",
    isPopular:true,
    rating:4.9,
    desc:"REAL UNREAL COSMOS is a non-fiction, physics & cosmology-based book that talks about the Simulation Hypothesis i.e in simple words: The universe - our world being the artificial reality that is no different than a video game. We all have played a lot of video games, but what if we were in one?  Ever wondered, Who & Where is God? the almighty creator that we pray and seek. Ever felt: Everything that happens with us - our victories, losses & luck isn't everything already preplanned? The universe in which we live, eat, feel, love, lose, and achieve itself only doesn't seem to be real or authentic reality.",
    categoryName: "non-fiction",
    deliveryCharge:false
  },
  {
    _id: uuid(),
    id: "Freedom_At_Midnight",
    title: "Freedom At Midnight",
    img:book14,
    price: "797",
    original_price:"1100",
    isPopular:false,
    rating:3.2,
    desc:"The book provides a detailed account of the last year of the British Raj; the reactions of princely states towards independence, including descriptions of the colourful and extravagant lifestyles of the Indian princes; the partition of British India (into India and Pakistan) on religious grounds; and the bloodshed that followed",
    categoryName: "non-fiction",
    deliveryCharge:false
  },
  {
    _id: uuid(),
    id: "India",
    title: "India: A History",
    img:book15,
    price: "774",
    original_price:"1723",
    isPopular:true,
    rating:4.1,
    desc:"India: A History, available in paperback, is a book which describes the country of India, in all its richness and glory, from times immemorial. Right from the first Harappan Civilization in the ancient times to the present day activities, this book is an attempt to paint a big picture of India to its readers.In this book, the author speaks about the distinct features of India. This country possesses so much continuity and diversity, that it's called a subcontinent. He describes how in spite of a common culture running through the blood of most people in India, this country has never been a single unitary state.",
    categoryName: "non-fiction",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "City_Of_DJINNS",
    title: "City Of Djinns",
    img:book16,
    price: "683",
    original_price:"797",
    isPopular:true,
    rating:4.7,
    desc:"The City of Djinns is one of the first books by William Dalrymple which doesn't revolve around the history of India, rather it represents various anecdotes of his time in India and explores the history of India with the help of various characters he meets.",
    categoryName: "non-fiction",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "I_will_teach_you_to_be_rich",
    title: "I Will Teach You To Be Rich",
    img:book17,
    price: "3424",
    original_price:"33,333",
    isPopular:true,
    rating:4.6,
    desc:"Sethi covers how to save time by not wasting it managing money; the guns and cars myth of credit cards; how to negotiate like an Indian--the conversation begins with no; why Budgeting Doesn't Have to Suck!; how to get things rolling--for real--with only $20; what most people don't understand about taxes; how to get a CEO to take you out to lunch; how to avoid the Super Mario Brothers trap by making your savings work harder than you do; the difference between cheap and frugal; the hidden relationship between money and food. ",
    categoryName: "finance",
    deliveryCharge:false
  },
  {
    _id: uuid(),
    id: "Rich_Dad_Poor_Dad",
    title: "Rich Dad Poor Dad",
    img:book18,
    price: "405",
    original_price:"599",
    isPopular:true,
    rating:4.1,
    desc:"April of 2022 marks a 25-year milestone for the personal finance classic Rich Dad Poor Dad that still ranks as the #1 Personal Finance book of all time. And although 25 years have passed since Rich Dad Poor Dad was first published,readers will find that very little in the book itself has changed ― and for good reason. While so much in our world is changing a high speed, the lessons about money and the principles of Rich Dad Poor Dad haven’t changed. Today, as money continues to play a key role in our daily lives, the messages in Robert Kiyosaki’s international bestseller are more timely and more important than ever.",
    categoryName: "finance",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "The_Intelligent_Investor ",
    title: "The Intelligent Investor ",
    img:book19,
    price: "402",
    original_price:"799",
    isPopular:true,
    rating:4.5,
    desc:"It is a widely acclaimed book by Benjamin Graham on value investing. Written by one of the greatest investment advisers of twentieth century, the book aims at preventing potential investors from substantial errors and also teaches them strategies to achieve long-term investment goals. Over the years, investment market has been following teachings and strategies of Graham for growth and development.",
    categoryName: "finance",
    deliveryCharge:false
  },
  {
    _id: uuid(),
    id: "The_Psychology_of_Money",
    title: "The Psychology of Money",
    img:book20,
    price: "210",
    original_price:"399",
    isPopular:true,
    rating:4.6,
    desc:"Timeless lessons on wealth, greed, and happiness doing well with money isn?t necessarily about what you know. It?s about how you behave. And behavior is hard to teach, even to really smart people. How to manage money, invest it, and make business decisions are typically considered to involve a lot of mathematical calculations, where data and formulae tell us exactly what to do. But in the real world, people don?t make financial decisions on a spreadsheet. They make them at the dinner table, or in a meeting room, where personal history, your unique view of the world, ego, pride, marketing, and odd incentives are scrambled together. In the psychology of money, the author shares 19 short stories exploring the strange ways people think about money and teaches you how to make better sense of one of life?s most important matters.",
    categoryName: "finance",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "SECRETS_OF_THE_MILLIONAIRE_MIND",
    title: "SECRETS OF MILLIONAIRE MIND",
    img:book21,
    price: "377",
    original_price:"499",
    isPopular:false,
    rating:4.3,
    desc:"Mastering the Inner Game of Wealth. Have you ever wondered why some people seem to achieve wealth effortlessly while others work just as hard but still struggle financially? In this fresh and original book T. Harv Eker explains how you too can master the inner game of money so that you will not only achieve financial success but keep it once you have it. Using breakthrough techniques T. Harv Eker shows you how childhood and family experiences and inner mental attitudes shape your view of money.",
    categoryName: "finance",
    deliveryCharge:false
  },
  {
    _id: uuid(),
    id: "SECRETS_OF_THE_MILLIONAIRE_MIND",
    title: "SECRETS OF THE MILLIONAIRE MIND",
    img:book22,
    price: "1374",
    original_price:"1540",
    isPopular:false,
    rating:4.1,
    desc:"A Refinery29 Best Book of 2018. One of Real Simple's Most Inspiring Books for Graduates Indie Personal Finance BestsellerHow to get good with money, even if you have no idea where to start.The Financial Diet is the personal finance book for people who don’t care about personal finance. Whether you’re in need of an overspending detox, buried under student debt, or just trying to figure out how to live on an entry-level salary, The Financial Diet gives you tools to make a budget, understand investments, and deal with your credit.",
    categoryName: "finance",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "Richest_Man_in_Babylon",
    title: "Richest Man in Babylon",
    img:book23,
    price: "99",
    original_price:"149",
    isPopular:false,
    rating:4.1,
    desc:"If you have a lean purse and are looking for financial wisdom, you?ve picked the perfect book!?A PART OF ALL YOU EARN IS YOURS TO KEEP.?From the importance of savings to the essentials on how to become wealthy, this collection of famous Babylonian parables imparts timeless financial wisdom.",
    categoryName: "finance",
    deliveryCharge:true
  },
  {
    _id: uuid(),
    id: "The_Financial_Diet",
    title: "The Financial Diet",
    img:book24,
    price: "1374",
    original_price:"1540",
    isPopular:false,
    rating:4.1,
    desc:"If you have a lean purse and are looking for financial wisdom, you?ve picked the perfect book!?A PART OF ALL YOU EARN IS YOURS TO KEEP.?From the importance of savings to the essentials on how to become wealthy, this collection of famous Babylonian parables imparts timeless financial wisdom.",
    categoryName: "finance",
    deliveryCharge:true
  }
];
